// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getFactoryCodeConstants} from '../../../shared/repositories';

export const updateDemoRentalFactoryCodes = () =>
    dispatch => getFactoryCodeConstants()
        .then(data => dispatch({
            data,
            type: actions.UPDATE_DEMO_RENTAL_FACTORY_CODE_SUCCESS
        }));




// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/action-creators/factory-codes.js